import type { PluginLanguage } from '../types.js'

export const enTranslations = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Name (lowercase, no special characters)',
    add: 'Add',
    allowedFileTypes: 'Allowed File Types',
    allowedFileTypesDescription:
      'Restrict allowed file types (e.g., image/*, application/pdf). Leave empty to allow all types.',
    allowMultipleFiles: 'Allow Multiple Files',
    amountInCents: 'Amount in cents',
    basePrice: 'Base Price',
    bcc: 'BCC',
    brand: 'Brand',
    cc: 'CC',
    checkboxPlural: 'Checkbox Fields',
    checkboxSingular: 'Checkbox',
    checkedByDefault: 'Checked by default',
    chooseConfirmationType:
      'Choose whether to display an on-page message or redirect to a different page after they submit the form.',
    condition: 'Condition',
    confirmationMessage: 'Confirmation Message',
    confirmationType: 'Confirmation Type',
    countryPlural: 'Country Fields',
    countrySingular: 'Country',
    creditCard: 'Credit Card',
    customURL: 'Custom URL',
    datePlural: 'Date Fields',
    dateSingular: 'Date',
    defaultValue: 'Default Value',
    divide: 'Divide',
    documentToLinkTo: 'Document to link to',
    doesNotEqual: 'Does Not Equal',
    emailFrom: 'Email From',
    emailPlural: 'Email Fields',
    emailsDescription:
      "Send custom emails when the form submits. Use comma separated lists to send the same email to multiple recipients. To reference a value from this form, wrap that field's name with double curly brackets, i.e. {{firstName}}. You can use a wildcard {{*}} to output all data and {{*:table}} to format it as an HTML table in the email.",
    emailSingular: 'Email',
    emailTo: 'Email To',
    equals: 'Equals',
    field: 'Field',
    fields: 'Fields',
    fieldWidth: 'Field Width (percentage)',
    hasAnyValue: 'Has Any Value',
    internalLink: 'Internal link',
    label: 'Label',
    maxFileSize: 'Max File Size (bytes)',
    maxFileSizeDescription: 'Maximum file size in bytes. Leave empty for no limit.',
    message: 'Message',
    messageDescription: 'Enter the message that should be sent in this email.',
    messagePlural: 'Message Blocks',
    messageSingular: 'Message',
    mimeType: 'MIME Type',
    mimeTypePlural: 'MIME Types',
    mimeTypeSingular: 'MIME Type',
    multiply: 'Multiply',
    numberPlural: 'Number Fields',
    numberSingular: 'Number',
    optionPlural: 'Options',
    optionSingular: 'Option',
    paymentFieldPlural: 'Payment Fields',
    paymentFieldSingular: 'Payment',
    paymentProcessor: 'Payment Processor',
    paymentStatus: 'Status',
    placeholder: 'Placeholder',
    priceConditions: 'Price Conditions',
    priceConditionsPlural: 'Price Conditions',
    priceConditionsSingular: 'Price Condition',
    radioOptions: 'Radio Attribute Options',
    radioPlural: 'Radio Fields',
    radioSingular: 'Radio',
    redirect: 'Redirect',
    replyTo: 'Reply To',
    required: 'Required',
    selectOptions: 'Select Attribute Options',
    selectPlural: 'Select Fields',
    selectSingular: 'Select',
    statePlural: 'State Fields',
    stateSingular: 'State',
    staticValue: 'Static Value',
    subject: 'Subject',
    submitButton: 'Submit Button Label',
    subtract: 'Subtract',
    textareaPlural: 'Text Area Fields',
    textareaSingular: 'Text Area',
    textPlural: 'Text Fields',
    textSingular: 'Text',
    title: 'Title',
    token: 'token',
    uploadCollection: 'Upload Collection',
    uploadCollectionDescription: 'Select which upload collection to store files in',
    uploadFieldPlural: 'Upload Fields',
    uploadFieldSingular: 'Upload',
    urlToRedirectTo: 'URL to redirect to',
    value: 'Value',
    valueOfField: 'Value Of Field',
    valueType: 'Value Type',
  },
}

export const en: PluginLanguage = {
  dateFNSKey: 'en-US',
  translations: enTranslations,
}
